import React from 'react';
import RedirectMessageLayout from '../common-components/RedirectMessageLayout';

const ForgotPasswordResponse: React.FC = () => {
  return (
    <RedirectMessageLayout
      title="Redirecting to WaveMaker Login Page"
      message="Reset password link email is on its way"
      redirectMessage="Redirecting to WaveMaker Login Page"
      redirectDelay={3000}
      redirectPath="/" // Will resolve to wmlogin
    />
  );
};

export default ForgotPasswordResponse; 